// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MBay","colMin":"styles_colMin__1xn-X"};